module.exports = __webpack_public_path__ + "static/img/service4.d1fe54a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service4.jpg
// module id = UW51
// module chunks = 21